import { useRouteQuery } from '@vueuse/router';
import { z } from 'zod';

export function useEmbedded() {
  const route = useRoute();
  const origin = useRouteQuery('origin', undefined, { transform: z.string().optional().parse });
  const isEmbedded = computed(() => route.query.embedded !== undefined); // Backward compatibility

  return {
    origin,
    isEmbedded,
  };
}
